import { RxCustomerAPI } from '@driftt/dapper'

export const api = {
  patchGoogleAnalytics(data) {
    return RxCustomerAPI.patch('/integrations/google_analytics', data)
      .checkStatus()
      .retryWithBackoff()
      .map(({ response }) => response)
  },

  getGoogleAnalyticsSettings() {
    return RxCustomerAPI.get('/integrations/google_analytics')
      .checkStatus()
      .retryWithBackoff()
      .mapResponse(response => response)
  }
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/googleAnalytics/api.js